import React from 'react'

import { t } from 'i18next'
import { Tag } from 'primereact/tag'

import { EInvoiceHistoryStatus } from '../../../data/model'

type Props = {
  status?: EInvoiceHistoryStatus
}

export const StatusTag: React.FC<Props> = ({ status }) => {
  if (status == null) return null

  const getTranslation = (status: EInvoiceHistoryStatus) =>
    STATUS_TRANSLATIONS[status] || ''

  const STATUS_TRANSLATIONS: Record<EInvoiceHistoryStatus, string> = {
    [EInvoiceHistoryStatus.Submitted]: t(
      'eInvoiceHistory.table.columns.status.options.submitted',
    ),
  }

  const getColor = (status: EInvoiceHistoryStatus) =>
    STATUS_COLORS[status] || ''

  const STATUS_COLORS: Record<EInvoiceHistoryStatus, string> = {
    [EInvoiceHistoryStatus.Submitted]: 'bg-green-200 text-green-900',
  }

  return <Tag value={getTranslation(status)} className={getColor(status)} />
}
